/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Offercard_Earlyaccess2Inputs */

const id_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses Awal`)
};

const ms_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses Awal`)
};

const da_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Access`)
};

const de_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Access`)
};

const en_us2_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Access`)
};

const es_es2_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso Anticipado`)
};

const es_mx2_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso anticipado`)
};

const fil_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Access`)
};

const fr_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès anticipé`)
};

const it_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso anticipato`)
};

const hu_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korai hozzáférés`)
};

const nl_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vroege toegang`)
};

const no_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidlig tilgang`)
};

const pl_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wczesny dostęp`)
};

const pt_br2_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Access`)
};

const pt_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso antecipado`)
};

const ro_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acces timpuriu`)
};

const fi_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Access`)
};

const sv_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Access`)
};

const vi_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Truy cập sớm`)
};

const tr_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erken Erişim`)
};

const cs_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předběžný přístup`)
};

const bg_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ранен достъп`)
};

const ru_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ранний доступ`)
};

const uk_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ранній доступ`)
};

const ar_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوصول المبكر`)
};

const hi_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अर्ली एक्सेस`)
};

const th_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เล่นก่อนใคร`)
};

const ja_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーリーアクセス`)
};

const zh_cn2_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Access`)
};

const zh_hant1_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Access`)
};

const ko_components_offercard_earlyaccess2 = /** @type {(inputs: Components_Offercard_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Access`)
};

/**
* | output |
* | --- |
* | "Early Access" |
*
* @param {Components_Offercard_Earlyaccess2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_offercard_earlyaccess2 = /** @type {((inputs?: Components_Offercard_Earlyaccess2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Offercard_Earlyaccess2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_offercard_earlyaccess2(inputs)
	if (locale === "ms") return ms_components_offercard_earlyaccess2(inputs)
	if (locale === "da") return da_components_offercard_earlyaccess2(inputs)
	if (locale === "de") return de_components_offercard_earlyaccess2(inputs)
	if (locale === "en-US") return en_us2_components_offercard_earlyaccess2(inputs)
	if (locale === "es-ES") return es_es2_components_offercard_earlyaccess2(inputs)
	if (locale === "es-MX") return es_mx2_components_offercard_earlyaccess2(inputs)
	if (locale === "fil") return fil_components_offercard_earlyaccess2(inputs)
	if (locale === "fr") return fr_components_offercard_earlyaccess2(inputs)
	if (locale === "it") return it_components_offercard_earlyaccess2(inputs)
	if (locale === "hu") return hu_components_offercard_earlyaccess2(inputs)
	if (locale === "nl") return nl_components_offercard_earlyaccess2(inputs)
	if (locale === "no") return no_components_offercard_earlyaccess2(inputs)
	if (locale === "pl") return pl_components_offercard_earlyaccess2(inputs)
	if (locale === "pt-BR") return pt_br2_components_offercard_earlyaccess2(inputs)
	if (locale === "pt") return pt_components_offercard_earlyaccess2(inputs)
	if (locale === "ro") return ro_components_offercard_earlyaccess2(inputs)
	if (locale === "fi") return fi_components_offercard_earlyaccess2(inputs)
	if (locale === "sv") return sv_components_offercard_earlyaccess2(inputs)
	if (locale === "vi") return vi_components_offercard_earlyaccess2(inputs)
	if (locale === "tr") return tr_components_offercard_earlyaccess2(inputs)
	if (locale === "cs") return cs_components_offercard_earlyaccess2(inputs)
	if (locale === "bg") return bg_components_offercard_earlyaccess2(inputs)
	if (locale === "ru") return ru_components_offercard_earlyaccess2(inputs)
	if (locale === "uk") return uk_components_offercard_earlyaccess2(inputs)
	if (locale === "ar") return ar_components_offercard_earlyaccess2(inputs)
	if (locale === "hi") return hi_components_offercard_earlyaccess2(inputs)
	if (locale === "th") return th_components_offercard_earlyaccess2(inputs)
	if (locale === "ja") return ja_components_offercard_earlyaccess2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_offercard_earlyaccess2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_offercard_earlyaccess2(inputs)
	return ko_components_offercard_earlyaccess2(inputs)
});
export { components_offercard_earlyaccess2 as "components.offerCard.earlyAccess" }